export const displayMixin = {
  methods: {
    removeInfo(id) {
      document.getElementById(id).style.display = 'none';
    },
    displayInfo(id){
      document.getElementById(id).style.display = 'block';
    }
  }
}